import React, { useState, useEffect } from 'react';
import { fetchWifiData } from '../data/getdata';
import '../css/APs.css';
import wifiIcon from '../svg/wifi.svg';
import moreIcon from '../svg/more.svg';
import openIcon from '../svg/open.svg';
import apsIcon from '../svg/Aps.svg';
import securityIcon from '../svg/security.svg';
import FilterSortBar from './FilterSortBarAps';
import APsDetails from './APsDetails';

const Aps = () => {
    const [apData, setAPData] = useState([]);
    const [otherData, setOTHERData] = useState([]);
    const [selectedAP, setSelectedAP] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [selectedOption, setSelectedOption] = useState('signal_strength');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const fetchedData = await fetchWifiData();
                setAPData(fetchedData.Detail.aps); // 假设AP数据位于fetchedData.Detail.aps中
                setOTHERData(fetchedData.Detail);
            } catch (error) {
                console.error('Error fetching AP data:', error);
            }
        };

        fetchData();
    }, []);

    const handleSortChange = (option, ascending) => {
        const sortedData = [...apData];
        sortedData.sort((a, b) => {
            let aValue = '';
            let bValue = '';

            switch (option) {
              case 'ap-name':
                  aValue = a.wifi_host.long_mfr_mac;
                  bValue = b.wifi_host.long_mfr_mac;
                  break;
              case 'signal_strength':
                  aValue = a.wifi_host.signal;
                  bValue = b.wifi_host.signal;
                  break;
              case 'BSSID-count':
                  aValue = a.wifi_item?.airwise_active_bssids?.length ?? 0;
                  bValue = b.wifi_item?.airwise_active_bssids?.length ?? 0;
                  break;
              case 'SSID-count':
                  aValue = a.wifi_item?.airwise_active_ssids?.length ?? 0;
                  bValue = b.wifi_item?.airwise_active_ssids?.length ?? 0;
                  break;
              case 'Channel-count':
                  aValue = a.wifi_item?.airwise_active_channels?.length ?? 0;
                  bValue = b.wifi_item?.airwise_active_channels?.length ?? 0;
                  break; 
              case 'Client-count':
                  aValue = a.wifi_item?.airwise_active_clients?.length ?? 0;
                  bValue = b.wifi_item?.airwise_active_clients?.length ?? 0;
                  break;
              // Add more sorting options as needed
              default:
                  break;
            }

            if (aValue < bValue) {
                return ascending ? -1 : 1;
            }
            if (aValue > bValue) {
                return ascending ? 1 : -1;
            }
            return 0;
        });

        setAPData(sortedData);
    };

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const handleAPClick = (ap) => {
        setSelectedAP(ap);
        setShowDetails(true);
    };

    const handleReturnClick = () => {
        setShowDetails(false);
        setSelectedAP(null);
    };

    const renderAPValue = (ap) => {
        switch (selectedOption) {
            case 'signal_strength':
                return `${ap.wifi_host.signal} dBm`;
            case 'ap-name':
                return ap.wifi_host.long_mfr_mac;
            case 'SSID-count':
                return `SSID数量：${ap.wifi_item?.airwise_active_ssids?.length ?? 0}`;
            case 'BSSID-count':
                return `BSSID数量：${ap.wifi_item?.airwise_active_bssids?.length ?? 0}`;
            case 'Channel-count':
                return `信道数量：${ap.wifi_item?.airwise_active_channels?.length ?? 0}`;
            case 'Client-count':
                return `客户端数量：${ap.wifi_item?.airwise_active_clients?.length ?? 0}`;
            default:
                return '';
        }
    };

    return (
        <div className="ap-container">
            <FilterSortBar onSortChange={handleSortChange} onOptionChange={handleOptionChange} />
            {!showDetails && (
                <div className="ap-list">
                    {apData.map((ap, index) => (
                        <div key={index} className="ap-block" onClick={() => handleAPClick(ap)}>
                            <img src={apsIcon} alt="AP Icon" className="aps-icon" /> 
                            <img src={moreIcon} alt="More" className="more-icon" />
                            <div className="ap-name">{ap.wifi_host.long_mfr_mac}</div>
                            <div className="signal_strength">{ap.wifi_host.signal} dBm</div>
                            <div className="ap-mfg_prefix">{ap.wifi_host.mfg_prefix ? ap.wifi_host.mfg_prefix : '\u00A0'}</div>
                            <div className="ap-value">{renderAPValue(ap)}</div>
                            <div className="SSID-count" style={{ display: 'none' }}>SSID数量：{ap.wifi_item?.airwise_active_ssids?.length ?? 0}</div>
                            <div className="BSSID-count"style={{ display: 'none' }}>BSSID数量：{ap.wifi_item?.airwise_active_bssids?.length ?? 0}</div>
                            <div className="Channel-count"style={{ display: 'none' }}>信道数量：{ap.wifi_item?.airwise_active_channels?.length ?? 0}</div>
                            <div className="Client-count"style={{ display: 'none' }}>客户端数量：{ap.wifi_item?.airwise_active_clients?.length ?? 0}</div>
                        </div>
                    ))}
                </div>
            )}
            {showDetails && selectedAP && (
                <div className="ap-details">
                    <APsDetails selectedAP={selectedAP} otherData={otherData} onReturn={handleReturnClick} />
                </div>
            )}
        </div>
    );
};

export default Aps;